import { api } from './BaseService'

export const getDressTypes = async () => {
    return await api.get(`/dress_types`)
}

export const getDressTypeById = async (id) => {
    return await api.get(`/dress_types/${id}`)
}

export const createDressType = async (data) => {
    return await api.post(`/dress_types`, data)
}
export const updateDressType = async (data) => {
    return await api.put(`/dress_types/${data?.get('id')}`, data)
}
export const deleteDressType = async (id) => {
    return await api.delete(`/dress_types/${id}`)
}
